import { Box, Flex, Text, Textarea } from "@chakra-ui/react";
import React from "react";

type ScoreBadgeProps = {
  score: number;
  label: string;
  color: string;
  isDisabled?: boolean;
};

export const ScoreBadge: React.FC<ScoreBadgeProps> = ({
  score,
  label,
  color,
  isDisabled,
}) => (
  <Flex flexDirection="column" minW="64px" py="1" align="center" mr="2">
    <Box
      display="flex"
      width="8"
      height="8"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      flexShrink={0}
      borderRadius="md"
      bg={isDisabled ? "gray.400" : color}
      fontWeight="500"
      fontSize="sm"
      color="white"
      mb={2}
    >
      {score}
    </Box>
    <Text color="gray.600" fontSize="xs" textAlign="center">
      {label}
    </Text>
  </Flex>
);

interface RubricRowProps {
  score: number;
  label: string;
  value: string;
  color: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  isDisabled?: boolean;
}

const QuestionFormRubricRow: React.FC<RubricRowProps> = ({
  score,
  label,
  value,
  color,
  onChange,
  onBlur,
  onFocus,
  isDisabled,
}) => {
  return (
    <Flex align="start" gap={2} w="100%">
      <ScoreBadge
        score={score}
        label={label}
        color={color}
        isDisabled={isDisabled}
      />
      <Textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        onFocus={onFocus}
        placeholder={`Describe the criteria for a score of ${score}...`}
        fontSize="sm"
        borderRadius="md"
        resize="vertical"
        isDisabled={isDisabled}
      />
    </Flex>
  );
};

export default QuestionFormRubricRow;
